import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const products = [{
  image: 'https://images.unsplash.com/photo-1556656793-062ff9878258?w=800&h=600&fit=crop',
  category: 'Wireless',
  name: 'Business Cellular and Wireless',
  price: '$45.00/mo',
  desc: 'Enterprise-grade mobile connectivity for your entire team.'
}, {
  image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800&h=600&fit=crop',
  category: 'Internet',
  name: 'Business Internet',
  price: '$69.99/mo',
  desc: 'High-speed fiber and broadband solutions for your office.'
}, {
  image: 'https://images.unsplash.com/photo-1596526131083-e8c633c948d2?w=800&h=600&fit=crop',
  category: 'Telephony',
  name: 'VoIP Desk Phone',
  price: '$149.99',
  desc: 'HD voice quality with cloud integration.'
}, {
  image: 'https://images.unsplash.com/photo-1582139329536-e7284fece509?w=800&h=600&fit=crop',
  category: 'Authentication',
  name: 'Multi-Format Fob Key (Pack of 5)',
  price: '$99.99',
  desc: 'Universal compatibility for all readers.'
}, {
  image: 'https://images.unsplash.com/photo-1521931961826-fe48677230a5?w=800&h=600&fit=crop',
  category: 'Telephony',
  name: 'UCaaS Unified Platform',
  price: '$19.99/user/mo',
  desc: 'All-in-one solution for phone, video, SMS, and eFax.'
}];
export function PricingSection({
  category
}: {
  category?: string;
}) {
  const filteredProducts = category ? products.filter(p => p.category === category) : products;
  return <section className="py-24 bg-[#F5F7F8]" id="pricing" data-id="element-284">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-285">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-286">
          <div className="max-w-2xl" data-id="element-287">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#011B33]" data-id="element-288">
              {category === 'Telephony' ? 'Professional VoIP Hardware' : 'Pro-Grade Hardware, Smart Savings.'}
            </h2>
          </div>
          <button className="text-[#22A39F] font-bold flex items-center gap-2 hover:gap-3 transition-all group" data-id="element-289">
            View All Hardware
            <ArrowRightIcon className="w-4 h-4 transition-transform" data-id="element-290" />
          </button>
        </div>

        {/* Product Grid */}
        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ${filteredProducts.length < 4 ? 'lg:flex lg:justify-center' : ''}`} data-id="element-291">
          {filteredProducts.map((product, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-100 flex flex-col group hover:shadow-xl hover:-translate-y-1 transition-all w-full lg:max-w-[300px]" data-id="element-292">
              <div className="h-48 overflow-hidden bg-slate-50" data-id="element-293">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-294" />
              </div>

              <div className="p-8 flex flex-col items-center text-center flex-grow" data-id="element-295">
                <div className="text-[10px] font-bold text-[#011B33] uppercase tracking-[0.2em] mb-2 opacity-60" data-id="element-296">
                  {product.category}
                </div>

                <h3 className="text-base font-bold text-[#011B33] mb-2 leading-tight min-h-[2.5rem] flex items-center justify-center" data-id="element-297">
                  {product.name}
                </h3>

                <p className="text-[11px] text-slate-500 mb-4 line-clamp-2" data-id="element-298">
                  {product.desc}
                </p>

                <div className="text-2xl font-black text-[#22A39F] mb-6" data-id="element-299">
                  {product.price}
                </div>

                <button className="mt-auto text-xs font-bold text-[#011B33] uppercase tracking-widest hover:text-[#22A39F] transition-colors" data-id="element-300">
                  View Details
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}